<template>
  <v-container fluid>
    <v-toolbar dense>
      <v-layout row justify-space-between fill-height>
        <v-flex xs2>
          <v-toolbar-title>Asset Schedules</v-toolbar-title>
        </v-flex>
        <v-flex xs8>
          <v-tabs v-model="tabIndex" fixed-tabs>
            <v-tab>Tanks</v-tab>
            <v-tab>T-Bins</v-tab>
            <v-tab>Porta-Tanks</v-tab>
            <v-tab>BBL-Ferms</v-tab>
          </v-tabs>
        </v-flex>
        <v-flex xs2>
          <v-spacer></v-spacer>
          <!-- <v-icon @click="refresh">refresh</v-icon> -->
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-layout row align-space-between justify-space-between>
      <v-btn small @click="previous4Weeks">Previous 30 Days</v-btn>
      <v-btn small @click="next4Weeks">Next 30 Days</v-btn>
    </v-layout>
    <v-layout row align-space-between justify-space-between>
      <v-btn small @click="previousWeek">Previous Week</v-btn>
      <v-btn small @click="nextWeek">Next Week</v-btn>
    </v-layout>
    <br>
    <v-divider></v-divider>
    <table>
      <tr>
        <th width=40%></th>
        <th v-for="date in dates" :key="date" align="center" valign="middle" width=40px height=30px>
          <font size=1>{{date}}</font>
        </th>
      </tr>
      <tr v-if="typeID == 6" v-for="(tank,index) in tanks" :key="tank.NAME">
        <td class="text-xs-left bold caption" width=165px>{{tank.NAME}} {{tankCapacity(tank)}} / {{(tankCapacity(tank) / 275).toFixed(2)}}</td>
        <template v-for="a in assets[index]">
          <td v-on:click="clicked(a)" :key="a.id" v-if="a.span" :colspan="a.span" align="center" valign="middle" bgcolor="purple">
            <font color="white" size=1>{{a.client}}</font>
          </td>
          <td v-else :key="a.id">
          </td>
        </template>
      </tr>
      <tr v-if="typeID == 8" v-for="(tbin,index) in tbins" :key="tbin.NAME">
        <td class="text-xs-left bold caption" width=150px>{{tbin.NAME}}</td>
        <template v-for="a in assets[index]">
          <td v-on:click="clicked(a)" :key="a.id" v-if="a.span" :colspan="a.span" align="center" valign="middle" bgcolor="purple">
            <font color="white" size=1>{{a.client}}</font>
          </td>
          <td v-else :key="a.id">
          </td>
        </template>
      </tr>
      <tr v-if="typeID == 14" v-for="(porta,index) in portaTanks" :key="porta.NAME">
        <td class="text-xs-left bold caption" width=150px>{{porta.NAME}}</td>
        <template v-for="a in assets[index]">
          <td v-on:click="clicked(a)" :key="a.id" v-if="a.span" :colspan="a.span" align="center" valign="middle" bgcolor="purple">
            <font color="white" size=1>{{a.client}}</font>
          </td>
          <td v-else :key="a.id">
          </td>
        </template>
      </tr>
      <tr v-if="typeID == 7" v-for="(bbl,index) in bblFerms" :key="bbl.NAME">
        <td class="text-xs-left bold caption" width=150px>{{bbl.NAME}}</td>
        <template v-for="a in assets[index]">
          <td v-on:click="clicked(a)" :key="a.id" v-if="a.span" :colspan="a.span" align="center" valign="middle" bgcolor="purple">
            <font color="white" size=1>{{a.client}}</font>
          </td>
          <td v-else :key="a.id">
          </td>
        </template>
      </tr>
    </table>
  </v-container>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
export default {
  data: () => ({
    today: moment(),
    dates: [],
    assets: [],
    payload: [],
    tabIndex: 0,
    vesselTypes: ['Tanks', 'T-Bins', 'Porta-Tanks', 'BBL-Ferms'],
    //    chosenVesselType: 'Tanks',
    typeID: 6,
    assetDictionary: {}
  }),
  created () {
    this.today = moment()
    this.getPayload()
    this.update()
  },
  watch: {
    tabIndex (nv, ov) {
      switch (nv) {
        case 0: this.typeID = 6; break
        case 1: this.typeID = 8; break
        case 2: this.typeID = 14; break
        case 3: this.typeID = 7; break
      }
      this.getPayload()
      this.update()
    }
    // ,
    // chosenVesselType (nv, ov) {
    //   if (this.chosenVesselType === 'Tanks') {
    //     this.typeID = 6
    //   }
    //   if (this.chosenVesselType === 'T-Bins') {
    //     this.typeID = 8
    //   }
    //   if (this.chosenVesselType === 'Porta-Tanks') {
    //     this.typeID = 14
    //   }
    //   this.getPayload()
    //   this.update()
    // }
  },
  computed: {
    tanks () {
      return this.$store.state.tanks
    },
    tbins () {
      return this.$store.state.tbins
    },
    portaTanks () {
      return this.$store.state.portatanks
    },
    bblFerms () {
      return this.$store.state.bblFerms
    }
  },
  methods: {
    clicked (a) {
      this.$store.state.client = a.wo.Client
      console.log(JSON.stringify(a, null, 2))
      this.$router.push({
        path: '/workorder',
        query: {
          id: a.wo.id
        }
      })
    },
    tankCapacity (tank) {
      // return round(pow($row['CYLINDERDIAMETER']/2,2)*3.1415927*$row['CYLINDERHEIGHT']/231+$row['INITIALGALLONS'],0);
      return Math.round(Math.pow(parseFloat(tank.CYLINDERDIAMETER)/2, 2)*3.1415927*parseFloat(tank.CYLINDERHEIGHT)/231)
    },
    refresh () {
      this.getPayload()
    },
    workOrderHasSameDate (tankName, dayNumber) {
      let id = tankName + '-' + dayNumber
      if (!this.assetDictionary[tankName]) return { item: { id: id }, advance: 1 }
      for (var i=0; i<this.assetDictionary[tankName].length; i++) {
        let wo = this.assetDictionary[tankName][i].WorkOrder
        var workOrderDate = moment(wo.date).add(15, 'hours')
        var dateToConsider = moment(this.today).add(dayNumber, 'days')
        var dayDifference = workOrderDate.diff(dateToConsider, 'days')
        if (dayDifference < 0 && dayNumber === 0) {
          var leftOverSpan = dayDifference + this.assetDictionary[tankName][i].estDaysInTank
          if (leftOverSpan > 0) {
            return { advance: leftOverSpan,
              item: { id: id,
                span: leftOverSpan,
                client: wo.clientCode,
                wo: wo,
                tankName: tankName }
            }
          }
        }
        if (dayDifference === 0) {
          let span = Math.min(this.assetDictionary[tankName][i].estDaysInTank, 30 - dayNumber)
          return { advance: (this.assetDictionary[tankName].estDaysInTank ? this.assetDictionary[tankName].estDaysInTank : 1),
            item: { id: id,
              span: span,
              client: wo.clientCode,
              wo: wo,
              tankName: tankName }
          }
        }
      }
      return { item: { id: id }, advance: 1 }
    },
    getPayload () {
      var url = process.env.VUE_APP_BACKEND + 'reservations?startDate='+ moment(this.today).format('YYYY-MM-DD') +
                '&endDate=' + moment(this.today).add(30, 'days').format('YYYY-MM-DD') + '&typeID=' + this.typeID
      console.log(url)
      axios
        .get(url)
        .then(response => {
          this.assetDictioary = {}
          this.payload=JSON.parse(JSON.stringify(response.data.data))
          this.payload.forEach(res => {
            if (!this.assetDictionary[res.Asset.NAME]) {
              this.assetDictionary[res.Asset.NAME] = []
            }
            this.assetDictionary[res.Asset.NAME].push(res)
          })
          this.assets = []
          if (this.typeID === 6) {
            for (var tankIndex=0; tankIndex<this.tanks.length; tankIndex++) {
              this.assets.push([])
            }
            for (tankIndex=0; tankIndex<this.tanks.length; tankIndex++) {
              var i = 0
              while (i < 30) {
                let result = this.workOrderHasSameDate(this.tanks[tankIndex].NAME, i)
                this.assets[tankIndex].push(result.item)
                if (result.item.span) {
                  i += result.item.span
                } else {
                  i++
                }
              }
            }
          }
          if (this.typeID === 7) {
            for (var index=0; index<this.tbins.length; index++) {
              this.assets.push([])
            }
            for (index=0; index<this.bblFerms.length; index++) {
              i = 0
              while (i < 30) {
                let result = this.workOrderHasSameDate(this.bblFerms[index].NAME, i)
                this.assets[index].push(result.item)
                if (result.item.span) {
                  i += result.item.span
                } else {
                  i++
                }
              }
            }
          }
          if (this.typeID === 8) {
            for (var tbinIndex=0; tbinIndex<this.tbins.length; tbinIndex++) {
              this.assets.push([])
            }
            for (tbinIndex=0; tbinIndex<this.tbins.length; tbinIndex++) {
              i = 0
              while (i < 30) {
                let result = this.workOrderHasSameDate(this.tbins[tbinIndex].NAME, i)
                this.assets[tbinIndex].push(result.item)
                if (result.item.span) {
                  i += result.item.span
                } else {
                  i++
                }
              }
            }
          }
          if (this.typeID === 14) {
            for (var portaIndex=0; portaIndex<this.portaTanks.length; portaIndex++) {
              this.assets.push([])
            }
            for (portaIndex=0; portaIndex<this.portaTanks.length; portaIndex++) {
              i = 0
              while (i < 30) {
                let result = this.workOrderHasSameDate(this.portaTanks[portaIndex].NAME, i)
                this.assets[portaIndex].push(result.item)
                if (result.item.span) {
                  i += result.item.span
                } else {
                  i++
                }
              }
            }
          }
          //   console.log(JSON.stringify(this.assets[5], null, 2  ))
        })
    },
    update () {
      this.dates = []
      for (var i=0; i<30; i++) {
        this.dates[i] = moment(this.today).add(i, 'days').format('MM/DD')
      }
    },
    previous4Weeks () {
      this.today = moment(this.today).subtract(30, 'days')
      this.update()
      this.getPayload()
    },
    next4Weeks () {
      this.today = moment(this.today).add(30, 'days')
      this.update()
      this.getPayload()
    },
    previousWeek () {
      this.today = moment(this.today).subtract(7, 'days')
      this.update()
      this.getPayload()
    },
    nextWeek () {
      this.today = moment(this.today).add(7, 'days')
      this.update()
      this.getPayload()
    }
  }
}
</script>
<style>
.fixed_header tbody{
  display:block;
  overflow:auto;
  height:200px;
  width:100%;
}
.fixed_header thead tr{
  display:block;
}
</style>
